import React, { Suspense } from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { LayoutSplashScreen, ContentRoute } from '../_metronic/layout'
import UserprofilePage, { UserProfile } from './pages/user/UserProfile'
import { NotificationList, NotificationDetail } from './pages/notification'
import { PortList, PortDetail } from './pages/port'
import * as path from '../app/constants/path'
import { UserList } from './pages/user'
import { TransactionList, TransactionDetail } from './pages/transaction'

import { KycDetail, KycList } from './pages/kyc'
import { BankAccountList, BankAccountDetail } from './pages/bankaccount'
import { ArticleList, ArticleDetail } from './pages/article'
import { Setting } from './pages/setting'
import { RewardImport, RewardList } from './pages/reward'
import RewardDetail from './pages/reward/RewardDetail'
import { BannerDetail, BannerList } from './pages/banner'
import { CampaignDetail, CampaignList } from './pages/campaign'
import { SellLimitPage } from './pages/sell-limit'
import { GoldTopUpDetail, GoldTopUpList } from './pages/goldtopup'
import TagList from './pages/tag/TagList'
import { TagDetail } from './pages/tag'
import { CategoryList } from './pages/category'
import { TopDeal } from './pages/top-deal'
import { ImportDcaList } from './pages/import-dca'
import ImportDcaRecordList from './pages/import-dca/ImportDcaRecordList'
import ImportDcaRecordDetail from './pages/import-dca/ImportDcaRecordDetail'
import { DcaDetail, DcaList } from './pages/dca'

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /users */
          <Redirect exact from="/" to={path.users()} />
        }

        <ContentRoute path="/users/:userId" component={UserProfile} />
        <ContentRoute path={path.users()} component={UserList} />
        <ContentRoute path="/usersnew" component={UserprofilePage} />
        <ContentRoute path={path.notificationCreate()} component={NotificationDetail} />
        <ContentRoute path={path.notificationDetail()} component={NotificationDetail} />
        <ContentRoute path={path.notification()} component={NotificationList} />

        <ContentRoute path={path.portDetail()} component={PortDetail} />
        <ContentRoute path={path.ports()} component={PortList} />
        <ContentRoute path={path.transactionDetail()} component={TransactionDetail} />
        <ContentRoute path={path.transactions()} component={TransactionList} />
        <ContentRoute path={path.kycDetail()} component={KycDetail} />
        <ContentRoute path={path.kycs()} component={KycList} />
        <ContentRoute path={path.bankAccountDetail()} component={BankAccountDetail} />
        <ContentRoute path={path.bankAccounts()} component={BankAccountList} />
        <ContentRoute path={path.setting()} component={Setting} />
        <ContentRoute path={path.bannerDetail()} component={BannerDetail} />
        <ContentRoute path={path.bannerCreate()} component={BannerDetail} />
        <ContentRoute path={path.banner()} component={BannerList} />

        <ContentRoute path={path.rewardCreate()} component={RewardImport} />
        <ContentRoute path={path.campaignDetail()} component={CampaignDetail} />
        <ContentRoute path={path.createCampaign()} component={CampaignDetail} />
        <ContentRoute path={path.campaign()} component={CampaignList} />
        <ContentRoute path={path.goldTopUpDetail()} component={GoldTopUpDetail} />
        <ContentRoute path={path.createGoldTopUp()} component={GoldTopUpDetail} />
        <ContentRoute path={path.goldTopUp()} component={GoldTopUpList} />

        <ContentRoute path={path.sellLimit()} component={SellLimitPage} />

        <ContentRoute path={path.articleDetail()} component={ArticleDetail} />
        <ContentRoute path={path.createArticle()} component={ArticleDetail} />
        <ContentRoute path={path.article()} component={ArticleList} />

        <ContentRoute path={path.rewardDetail()} component={RewardDetail} />
        <ContentRoute path={path.rewards()} component={RewardList} />

        <ContentRoute path={path.tagDetail()} component={TagDetail} />
        <ContentRoute path={path.createTag()} component={TagDetail} />
        <ContentRoute path={path.tag()} component={TagList} />
        <ContentRoute path={path.category()} component={CategoryList} />
        <ContentRoute path={path.topDeal()} component={TopDeal} />
        <ContentRoute path={path.dcaDetail()} component={DcaDetail} />
        <ContentRoute path={path.dca()} component={DcaList} />

        <ContentRoute path={path.dcaRecordDetail()} component={ImportDcaRecordDetail} />
        <ContentRoute path={path.dcaRecordList()} component={ImportDcaRecordList} />
        <ContentRoute path={path.bulkDca()} component={ImportDcaList} />
        <Redirect exact from="/dashboard" to={path.users()} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  )
}
